module.exports = __webpack_public_path__ + "static/media/minus_icon.3a7c33c1.svg";